import React from 'react';
import SolutionContractWaitingContainer from 'containers/SolutionContractWaitingContainer';

export default function SolutionContractWaitingPage() {
  return (
    <SolutionContractWaitingContainer />
  )
}
